import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import routes from "./route/routes.config";

const renderChildRoutes = (children) =>
  children?.map((childRoute, childIndex) => {
    if (childRoute.index) {
      return (
        <Route key={childIndex} index element={childRoute.element} />
      );
    }

    return (
      <Route
        key={childIndex}
        path={childRoute.path}
        element={childRoute.element}
      >
        {renderChildRoutes(childRoute.children)}
      </Route>
    );
  });

function App() {
  return (
    <Router>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {renderChildRoutes(route.children)}
          </Route>
        ))}
      </Routes>
    </Router>
  );
}

export default App;
